import Vue from 'vue';
import Vuex from 'vuex';

import auth from './auth';
import page from './page';
import snackbar from './snackbar';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  modules: {
    auth,
    page,
    snackbar,
  },
});
